<script setup lang="ts">
import { computed } from "vue"
import { useTranslation } from "@/composables"
import { RsvpStatus } from "@/models"

const props = defineProps<{
  status: RsvpStatus
}>()

const { t } = useTranslation()

const statusDetails = computed(() => {
  return {
    attending: { label: t("rsvp_response_status.attending"), color: "bg-green-100 text-green-800" },
    declined: { label: t("rsvp_response_status.declined"), color: "bg-red-100 text-red-800" },
    maybe: { label: t("rsvp_response_status.maybe"), color: "bg-yellow-100 text-yellow-800" },
    pending: { label: t("rsvp_response_status.pending"), color: "bg-gray-100 text-gray-800" },
    noResponse: { label: t("rsvp_response_status.no_response"), color: "bg-gray-100 text-gray-800" },
    none: { label: t("rsvp_response_status.none"), color: "bg-gray-100 text-gray-800" },
  }
})

const detailsByStatus = computed<Record<RsvpStatus, { label: string, color: string }>>(() => ({
  [RsvpStatus.ATTENDING]: statusDetails.value.attending,
  [RsvpStatus.NOT_ATTENDING]: statusDetails.value.declined,
  [RsvpStatus.MAYBE]: statusDetails.value.maybe,
  [RsvpStatus.PENDING]: statusDetails.value.pending,
  [RsvpStatus.NO_RESPONSE]: statusDetails.value.noResponse,
  [RsvpStatus.NONE]: statusDetails.value.none,
}))

const details = computed(() => {
  return detailsByStatus.value[props.status]
})
</script>

<template>
  <span
    class="inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold whitespace-nowrap"
    :class="details.color"
  >
    {{ details.label }}
  </span>
</template>
